var render = function render(){
  var _vm$profile, _vm$profile$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "full-width": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "account-icon-ctn",
          class: {
            'collapsed': _vm.isCollapsed
          }
        }, 'div', attrs, false), on), [_c('div', {
          staticClass: "account-icon pr-2"
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("mdi-account-circle")])], 1)], 1), _c('div', {
          staticClass: "account-text pl-2",
          class: {
            'collapsed': _vm.isCollapsed
          }
        }, [_c('span', {
          staticClass: "account-text-content"
        }, [_vm._v(_vm._s(_vm.$t('profile.my')))])])])];
      }
    }])
  }, [_c('v-list', {
    staticClass: "pa-5",
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "navigation-menu-title mb-2"
  }, [_vm._v(" " + _vm._s(_vm.profile.first_name) + " " + _vm._s(_vm.profile.last_name) + " ")]), _c('div', {
    staticClass: "navigation-menu-sub-title mb-4"
  }, [_vm._v(_vm._s(_vm.profile.email))]), _c('div', {
    staticClass: "navigation-menu-sub-title mb-2"
  }, [_vm._v(_vm._s((_vm$profile = _vm.profile) === null || _vm$profile === void 0 ? void 0 : (_vm$profile$company = _vm$profile.company) === null || _vm$profile$company === void 0 ? void 0 : _vm$profile$company.name))]), _c('div', {
    staticClass: "navigation-menu-label mb-2"
  }, [_vm._v(_vm._s(_vm.$t('current_plan')))]), _c('div', {
    staticClass: "navigation-menu-plan-label mb-5"
  }, [_vm._v(_vm._s(_vm.planName))]), _c('div', {
    staticClass: "mb-5"
  }, [_c('router-link', {
    staticClass: "profile-btn py-2 px-3 font-weight-medigum",
    attrs: {
      "ter-link": "",
      "to": {
        name: 'profile.info'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.closeOnClick.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.manage_my_account')) + " ")])], 1), _c('div', {
    staticClass: "border-bottom"
  }), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('LanguageSelect')], 1)], 1), _c('div', [_c('a', {
    staticClass: "primary-text d-flex",
    on: {
      "click": function ($event) {
        return _vm.openHelpCenterArticle('https://help.scantrust.com/hc/en-us');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1 primary-text"
  }, [_vm._v("mdi-help-circle")]), _c('span', {
    staticClass: "text-decoration-underline"
  }, [_vm._v(_vm._s(_vm.$t('profile.help_center')))])], 1)]), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "ml-auto"
  }, [_c('v-btn', {
    staticClass: "font-weight-medium text-capitalize px-0",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18",
      "color": "#555555"
    }
  }, [_vm._v("mdi-logout")]), _c('span', {
    staticClass: "navigation-menu-logout-text"
  }, [_vm._v(_vm._s(_vm.$t('logout')))])], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }